export function Logo({ className }: { className: any }) {
  return process.env.NEXT_PUBLIC_APP_LOGO ? (
    <img src={process.env.NEXT_PUBLIC_APP_LOGO} className={className} />
  ) : (
    <>
      <svg className={className} width="1000" height="678" viewBox="0 0 1000 678" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M164.21 72.5675C153.028 37.8559 178.915 2.31934 215.384 2.31934H384.691C408.032 2.31934 428.708 17.3805 435.865 39.598L638.91 669.913H419.299C381.952 669.913 348.872 645.815 337.421 610.268L164.21 72.5675Z" fill="url(#paint0_linear_2610_7)" />
        <path d="M144.453 219.227L288.02 668.986H93.8969C33.2586 668.986 -8.34554 607.928 13.8389 551.494L144.453 219.227Z" fill="url(#paint1_linear_2610_7)" />
        <path d="M786.375 39.5981C779.218 17.3805 758.543 2.31934 735.202 2.31934H565.895C529.427 2.31934 503.539 37.8559 514.721 72.5675L687.931 610.268C699.383 645.815 732.464 669.913 769.81 669.913H989.421L786.375 39.5981Z" fill="url(#paint2_linear_2610_7)" />
        <defs>
          <linearGradient id="paint0_linear_2610_7" x1="116.514" y1="719.505" x2="463.08" y2="-107.029" gradientUnits="userSpaceOnUse">
            <stop stop-color="#5493FF" />
            <stop offset="0.5" stop-color="#AF3FFF" />
            <stop offset="1" stop-color="#FF82FA" />
          </linearGradient>
          <linearGradient id="paint1_linear_2610_7" x1="116.514" y1="719.505" x2="463.079" y2="-107.029" gradientUnits="userSpaceOnUse">
            <stop stop-color="#5493FF" />
            <stop offset="0.5" stop-color="#AF3FFF" />
            <stop offset="1" stop-color="#FF82FA" />
          </linearGradient>
          <linearGradient id="paint2_linear_2610_7" x1="116.514" y1="719.505" x2="463.08" y2="-107.029" gradientUnits="userSpaceOnUse">
            <stop stop-color="#5493FF" />
            <stop offset="0.5" stop-color="#AF3FFF" />
            <stop offset="1" stop-color="#FF82FA" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
}
